import classNames from 'classnames'
import { FC } from 'react'
import ImageWithFallback from './ImageWithFallback'

type BlendMode =
  | 'normal'
  | 'multiply'
  | 'screen'
  | 'overlay'
  | 'darken'
  | 'lighten'
  | 'color-dodge'
  | 'color-burn'
  | 'hard-light'
  | 'soft-light'
  | 'difference'
  | 'exclusion'
  | 'hue'
  | 'saturation'
  | 'color'
  | 'luminosity'
  | 'plus-darker'
  | 'plus-lighter'

type BlendedImageProps = {
  src: string
  alt: string
  width?: number
  height?: number
  blended?: BlendMode
  className?: string
  overlayClassName?: string
  fill?: boolean
  sizes?: string
}

const BlendedImage: FC<BlendedImageProps> = ({ src, alt, width, height, className, overlayClassName, fill, sizes, blended = 'normal' }) => {
  return (
    <div className="relative w-full h-full">
      <div className={classNames('absolute top-0 left-0 w-full h-full bg-KMRS-Darkmode', overlayClassName)} />
      <ImageWithFallback
        className={classNames(`mix-blend-${blended} w-full h-full object-cover`, className)}
        width={width}
        height={height}
        src={src}
        alt={alt}
        fill={fill}
        sizes={sizes}
        fallbackSrc="/images/mocks/mock-bg.jpg"
      />
    </div>
  )
}

export default BlendedImage
